module.exports = __webpack_public_path__ + "static/media/D.A.D.A._Flyer.1ccc8cd4.pdf";